<script lang="ts">
    import { Link } from "svelte-routing";
    import ShareRose from "./ShareRose.svelte";
    import { Rose } from "../rose.ts";
    import NavigationButton from "../shared/NavigationButton.svelte";
    import { draw } from "svelte/transition";
    import { linear } from "svelte/easing";

    export let rose: Rose;

    // let svg;
    // let parser;
    // let SvgDoc;
    // let pathElems;
    // let pathArray;

    // fetch("../dibuix.svg").then(data => data.text()).then(txt => {
    //     svg = txt.replace('width="512"', '').replace('height="512"', '').replaceAll("sketch", "")

    //     parser = new DOMParser();
    //     SvgDoc = parser.parseFromString(svg, 'image/svg+xml');
    //     pathElems = SvgDoc.querySelectorAll('path');
    //     pathArray = Array.from(pathElems);

    // }).catch(err => console.error(err));

    // let playing = false
    // let maxtime = 6000; // ms
    // let duration = 0;

    // const play = () => {
    //     duration = maxtime / pathArray.length;
    //     playing = !playing;
    // }
</script>

<svelte:head>
    <title>Roses UPC - Detalls</title>
</svelte:head>

<div id="image-info-container">
    <div class="img-container">
        <img class="selected-image" src={rose.resultat} alt="Rosa" />
        <img
            src={rose.gargot}
            alt="esbos Rosa"
            class="selected-image"
            id="gargot"
        />
    </div>
    <div id="selected-image-info">
        <p>
            Inspirada en el dibuix que es mostra i amb la descripció "{rose.description}"
        </p>
        <ShareRose {rose} />
    </div>
</div>

<div>
    <br />
    <p class="details-info-text">
        Les imatges s’han creat mitjançant models generatius de <i>deep learning</i>, que consten 
        d’una arquitectura de xarxes neuronals que permeten produir una imatge a partir d’un dibuix senzill i d’un text.
    </p>
    <p class="details-info-text">
        El model s’inicia a partir del teu dibuix i la descripció facilitada, tot seguit l’algorisme va modificant el dibuix 
        perquè s’aproximi a la descripció introduïda, amb una imatge d’una rosa com a base de la imatge.
    </p>

    <div class="row-buttons">
        <NavigationButton to="informacio" text="Vols saber-ne més?" />
        <NavigationButton to="galeria" text="Anar a la galeria" />
    </div>

    <p class="details-info-text">
        Aquesta rosa s'ha generat a partir del model de codi obert anomenat <i>Controlnet</i>
        que permet generar imatges a partir d'un text i un dibuix senzill (<a
            href="https://github.com/lllyasviel/ControlNet"
            target="_blank"
            class="text-link">Original model & code on GitHub</a
        >)
        <br />
        Aquesta rosa es pot distribuir lliurement sense fer-ne un ús comercial sota la llicència
        <a
            href="https://creativecommons.org/licenses/by-nc-nd/4.0/"
            target="_blank"
            class="text-link">Creative Commons CC BY-NC-ND 4.0</a
        >.
    </p>
</div>

<style>
    .img-container {
        display: flex;
    }

    #image-info-container {
        display: flex;
        flex-direction: column;
        gap: 1em;
    }

    .selected-image {
        width: min(400px, 50%);
        max-width: 400px;
    }

    #gargot {
        width: min(400px, 50%);
        max-width: 400px;
        display: flex;
        flex-direction: row;
    }

    @media (max-width: 500px) {
        .img-container {
            flex-direction: column;
        }
        .selected-image,
        #gargot {
            width: min(400px, 90%);
        }
    }
</style>
